import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

/**
 * Directive to enable drag-and-drop file upload functionality on an element.
 * This directive flags the element while a drag is over it and emits the
 * dropped file list via an output event.
 */
@Directive({
    selector: '[dragAndDrop]'
})
/**
 * Class for Drag and Drop Directive
 */
export class DragAndDropDirective {

    @Output() fileDropped = new EventEmitter<FileList>(); /** Emits a `FileList` object when files are dropped on the element. */
    /** Flags the drag-over state for the stylesheet, in place of fading the whole element out. */
    @HostBinding('class.is-dragover') isDragOver = false;


    /**
 * Triggered when a file is dragged over the element.
 * Sets the drag-over state.
 *
 * @param event The dragover event.
 */
    @HostListener('dragover', ['$event']) onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = true;
    }

    /**
  * Triggered when the drag leaves the element.
  * Clears the drag-over state.
  *
  * @param event The dragleave event.
  */
    @HostListener('dragleave', ['$event']) public onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;
    }


    /**
     * Triggered when files are dropped on the element.
     * Emits the file list and clears the drag-over state.
     *
     * @param event The drop event.
     */
    @HostListener('drop', ['$event']) public ondrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;
        const files = event.dataTransfer?.files;
        if (files && files.length > 0) {
            this.fileDropped.emit(files)
        }
    }

}
